/**
 * Протух ли ход у клиента: серверный дедлайн текущего хода прошел заметно
 * раньше, а новых экшенов так и не пришло.
 *
 * Сервер сам завершает ход по таймеру и рассылает экшены смены фазы, поэтому в
 * норме дедлайн переживается на секунду с небольшим: отсрочка сервера
 * (TURN_AUTO_END_GRACE_MS в utils/phase/turnTimeLimits) плюс доставка.
 * Просрочка на graceMs — он должен быть заметно больше этой отсрочки — означает,
 * что клиент отстал от матча: экшен потерялся, канал молча умер, или пакет
 * смены хода отбраковал гвард фазы. Что именно — здесь неважно: лечение одно,
 * запросить у сервера полное состояние.
 *
 * @param {Object} params
 * @param {number|null} params.turnEndTimestamp - серверное время НАЧАЛА хода
 * @param {number} params.phaseDurationMs - сколько отведено фазе (0 — без лимита)
 * @param {number} params.nowMs - текущее время, уже скорректированное на serverTimeDelta
 * @param {number} params.graceMs - запас сверх дедлайна
 * @returns {boolean}
 */
export const checkIfTurnStateStale = ({turnEndTimestamp, phaseDurationMs, nowMs, graceMs}) => {
  if (!turnEndTimestamp || !phaseDurationMs) return false;
  return nowMs > turnEndTimestamp + phaseDurationMs + graceMs;
};
